import React from 'react';
import { format } from 'date-fns';
import Chisholm from '../../../common/config/Chisholm';

import WrapOverText from './WrapOverText';

function ValueDate(props) {
  var getDateFormat = Chisholm[props.dateFormat];
  var convertedDate = props.value == null ? '' : format(new Date(props.value), getDateFormat);

  return (
    <WrapOverText wrapOver={props.wrapOver} value={convertedDate} />
  )
}

export default ValueDate;
